import * as React from "react";

const PageBreaker = () => {
  return <div style={{ pageBreakAfter: "always" }} />;
};

export default PageBreaker;



// WEBPACK FOOTER //
// ./src/containers/SummaryPDF/components/PageBreaker.jsx